import { render, staticRenderFns } from "./AiMarkdown.vue?vue&type=template&id=06a30a5e&scoped=true"
import script from "./AiMarkdown.vue?vue&type=script&lang=js"
export * from "./AiMarkdown.vue?vue&type=script&lang=js"
import style0 from "./AiMarkdown.vue?vue&type=style&index=0&id=06a30a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a30a5e",
  null
  
)

export default component.exports